package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/** The texts of the artifact area. */
interface ArtifactStrings {
    val previewTab: String

    val codeTab: String

    val desktopWidth: String

    val mobileWidth: String

    val emptyState: String

    val emptyHint: String

    val previewLoading: String

    val codeNotInSession: String

    val download: String

    val copyLink: String

    val linkCopied: String

    fun copyLinkTitle(version: String): String

    val versionsGroup: String

    val allVersions: String

    val previewTitle: String

    val moreToCome: String

    val preparing: String

    val chatWidth: String

    fun downloadVersion(version: String): String

    fun downloadVersionLabel(version: String): String

    fun viewVersion(version: String): String

    fun allVersionsLabel(count: Int): String

    fun versionCount(count: Int): String

    val regionLabel: String

    val fullscreen: String

    val exitFullscreen: String

    val moreTools: String
}

/** The artifact area in Spanish. */
internal object SpanishArtifactStrings : ArtifactStrings {
    override val previewTab: String = "Vista previa"

    override val codeTab: String = "Código"

    override val desktopWidth: String = "Ancho de escritorio"

    override val mobileWidth: String = "Ancho de móvil"

    override val emptyState: String = "Aquí aparecerá tu página."

    override val emptyHint: String = "Cuéntame en la conversación qué necesitas y empezará a escribirse aquí mismo, sección a sección. Suele tardar alrededor de un minuto."

    override val previewLoading: String = "Cargando la vista previa…"

    override val codeNotInSession: String = "El código de esta versión no está en esta sesión. Puedes verla y descargarla."

    override val download: String = "Descargar"

    override val copyLink: String = "Copiar enlace"

    override val linkCopied: String = "Enlace copiado"

    override fun copyLinkTitle(version: String): String = "Enlace para enseñar la versión $version"

    override val versionsGroup: String = "Versiones de la página"

    override val allVersions: String = "Todas las versiones"

    override val previewTitle: String = "Vista previa de la página generada"

    override val moreToCome: String = "y lo que venga…"

    override val preparing: String = "montando la base…"

    override val chatWidth: String = "Ancho de la conversación"

    override fun downloadVersion(version: String): String = "Descargar la versión $version"

    override fun downloadVersionLabel(version: String): String = "Descargar la versión $version de la página"

    override fun viewVersion(version: String): String = "Ver la versión $version"

    override fun allVersionsLabel(count: Int): String = "Ver todas las versiones ($count)"

    override fun versionCount(count: Int): String = when (count) {
        1 -> "1 versión"
        else -> "$count versiones"
    }

    override val regionLabel: String = "La página generada"

    override val fullscreen: String = "Ver a pantalla completa"

    override val exitFullscreen: String = "Salir de pantalla completa"

    override val moreTools: String = "Más opciones"
}

/** The artifact area in English. */
internal object EnglishArtifactStrings : ArtifactStrings {
    override val previewTab: String = "Preview"

    override val codeTab: String = "Code"

    override val desktopWidth: String = "Desktop width"

    override val mobileWidth: String = "Mobile width"

    override val emptyState: String = "Your page will appear here."

    override val emptyHint: String = "Tell me in the conversation what you need and it will start writing itself right here, section by section. It usually takes about a minute."

    override val previewLoading: String = "Loading the preview…"

    override val codeNotInSession: String = "The code for this version is not in this session. You can view and download it."

    override val download: String = "Download"

    override val copyLink: String = "Copy link"

    override val linkCopied: String = "Link copied"

    override fun copyLinkTitle(version: String): String = "A link to show version $version"

    override val versionsGroup: String = "Page versions"

    override val allVersions: String = "All versions"

    override val previewTitle: String = "Preview of the generated page"

    override val moreToCome: String = "and whatever comes next…"

    override val preparing: String = "setting up the base…"

    override val chatWidth: String = "Conversation width"

    override fun downloadVersion(version: String): String = "Download version $version"

    override fun downloadVersionLabel(version: String): String = "Download version $version of the page"

    override fun viewVersion(version: String): String = "View version $version"

    override fun allVersionsLabel(count: Int): String = "View all versions ($count)"

    override fun versionCount(count: Int): String = when (count) {
        1 -> "1 version"
        else -> "$count versions"
    }

    override val regionLabel: String = "The generated page"

    override val fullscreen: String = "View full screen"

    override val exitFullscreen: String = "Exit full screen"

    override val moreTools: String = "More options"
}
